import {Link} from 'react-router-dom'
import {PageTitle} from '../../../_metronic/layout/core'

const Forbidden403 = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>Access denied</PageTitle>
      <div className='card shadow-sm mx-auto' style={{maxWidth: 520}}>
        <div className='card-body text-center p-10 p-lg-15'>
          <h1 className='text-gray-800 fw-bolder mb-3'>403 — Forbidden</h1>
          <p className='text-gray-600 mb-8'>
            You don&apos;t have permission to view this page. Contact a Super Admin if you need
            access.
          </p>
          <Link to='/dashboard' className='btn btn-primary'>
            Back to dashboard
          </Link>
        </div>
      </div>
    </>
  )
}

export default Forbidden403
